module.exports = __webpack_public_path__ + "files/Pivacy voorwaarden.1a96edbd.pdf";